import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import Torpedo from '../BaseTorpedo';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
function getMeasuredContainer(containerFromProps, measuredContainer) {
    var _measuredContainer_width;
    return {
        width: Number((_measuredContainer_width = measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width) !== null && _measuredContainer_width !== void 0 ? _measuredContainer_width : containerFromProps.width)
    };
}
const MeasuredTorpedo = (props)=>{
    const { ref, dimensions } = useMeasureElementCookie(props.cookieType, {
        cookieDim: 'width',
        defaultSize: props.defaultSize
    });
    useDebugRerenders('MeasuredTorpedo', _object_spread_props(_object_spread({}, props), {
        dimensions
    }));
    const container = getMeasuredContainer(props.container, dimensions);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, /*#__PURE__*/ React.createElement(Torpedo, _object_spread_props(_object_spread({}, props), {
        container: container
    }))));
};
MeasuredTorpedo.displayName = 'MeasuredTorpedo';
export default MeasuredTorpedo;

//# sourceMappingURL=MeasuredTorpedo.js.map